export default {
  v3OfficialTopUpCenterTitle: 'Pusat Top up Website Official',
  v3OfficialTopUpCenterKeyword: 'Pusat Top up Website Official',
  v3OfficialTopUpCenterDescription: 'Pusat Top up Website Official',
  v3SafeAndFast: 'Aman Tanpa Risiko, Langsung Diterima',
  v3Shop: 'Mall',
  v3ShoppingCart: 'Keranjang',
  v3MembershipCenter: 'Pusat Benefit (Pusat Anggota)',
  v3Login: 'Login',
  v3Account: 'Akun',
  v3EnterAccountName: 'Silakan masukkan nama akun',
  v3Password: 'Kata Sandi',
  v3EnterPassword: 'Silakan masukkan Kata Sandi',
  v3ForgotPassword: 'Lupa Kata Sandi',
  v3EnterUID: 'Silakan masukkan UID',
  v3OTP: 'OTP',
  v3EnterOTP: 'Silakan masukkan OTP',
  v3SelectTopUpCharacter: 'Pilih karakter Top up',
  v3SelectServer: 'Silakan pilih server',
  v3Confirm: 'Konfirmasi',
  v3CharacterNotFound:
    'Jika tidak dapat menemukan karakter, silakan coba login karakter di aplikasi game terlebih dahulu lalu masuk ke halaman Top-up atau hubungi CS',
  v3Logout: 'Log Out',
  v3SwitchAccount: 'Ganti akun',
  v3MyCoupons: 'Kupon Aku',
  v3BenefitsCenter: 'Pusat Anggota',
  v3TopUpBenefits: 'Benefit Top up',
  v3MoreSettings: 'Setting Lain',
  v3RememberLoginStatus: 'Simpan status Login-ku',
  v3OrderQuery: 'Cek Pesanan',
  v3ContactCustomerService: 'Hubungi CS',
  v3LoginWithApp: 'Login via Aplikasi',
  v3ChooseOtherLoginMethod: 'Pilih cara login lain',
  v3ConnectingToGameApp: 'Sedang dihubungkan ke aplikasi game',
  v3EnsureGameInstalled:
    'Pastikan perangkat telah menginstal game. Jika game tidak responsif atau gagal login, silakan upgrade game ke versi terbaru dari Store atau ubah ke browser lain.',
  v3OpenGame: 'Buka Game',
  v3DownloadGame: 'Unduh Game',
  v3UpdateGameIfOpenFails:
    'Jika game gagal dibuka, silakan upgrade game ke versi terbaru dari store',
  v3ClickToDownloadLatestVersion:
    'atau tekan tombol unduh game untuk mengunduh versi terbaru',
  v3LoggingIntoOfficialTopUpCenter:
    'Anda sedang login [Pusat Top up Website Official]',
  v3CurrentAccount: 'Akun saat ini: xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter:
    'Selamat menggunakan Pusat Top up Website Official',
  v3OfficialAuthorizedLogin:
    'Login yang diotorisasi official, aman tanpa risiko',
  v3TermsOfService: 'Ketentuan Layanan',
  v3PrivacyPolicy: 'Kebijakan Privasi',
  v3ThirdPartySocialAccountDescription: 'Penjelasan akun medsos pihak ketiga',
  v3BindSocialAccountInGameFirst:
    'Harap selesaikan bind akun medsos di Pusat Pengguna game, lalu gunakan akun medsos terikat untuk login.',
  v3FirstTopUp15PercentOff: 'Top-up perdana bisa menikmati max diskon 15%',
  v3MoreTopUpRebates: 'Banyak rabat untuk Top-up lainnya',
  v3LoginToViewOffers: 'Login untuk cek diskon',
  v3TopUpEnvironmentChecking: 'Verifikasi lingkungan Top-up...',
  v3SafeToUse: 'Aman, bisa digunakan',
  v3LimitedTimeBenefits: 'Benefit Waktu Terbatas',
  v3EventRules: 'Aturan',
  v3MoreEvents: 'Event lainnya',
  v3Claim: 'Klaim',
  v3Completed: 'Selesai',
  v3GoTo: 'Menuju',
  v3ViewDetails: 'Cek detail',
  v3RecommendedProducts: 'Rekomendasi Item',
  v3SearchProductName: 'Cari Nama Item',
  v3AllCategories: 'Semua Tipe',
  v3PopularSort: 'Sortir Populer',
  v3PriceAscending: 'Dari Harga Rendah',
  v3PriceDescending: 'Dari Harga Tinggi',
  v3DiamondBonus10Percent: 'Diamond tambah 10%',
  v3YuanbaoBonus10Percent: 'Ingot tambah 10%',
  v3ExtraBonus10Percent: 'Bonus 10%',
  v3FirstTopUpDouble: '2X Top-up Perdana',
  v3FirstExtraBonus: 'Bonus Top-up Perdana',
  v3ProductDetails: 'Rincian Item',
  v3AddToCart: 'Tambahkan ke Keranjang',
  v3AddedToCart: 'Sudah ditambahkan',
  v3BuyNow: 'Beli Sekarang',
  v3NoItemsInCart: 'Anda belum pilih item',
  v3SelectedItemsN: 'Item terpilih (${n})',
  v3RemoveFromCart: 'Hapus dari Keranjang?',
  v3Yes: 'Ya',
  v3No: 'Tidak',
  v3LimitOnePerPurchase: 'Limit beli item ini hanya 1',
  v3ItemPrice: 'Harga Item',
  v3Tax: 'Pajak',
  v3ExtraGift: 'Bonus',
  v3Total: 'Total',
  v3ProceedToPayment: 'Bayar',
  v3SelectCoupon: 'Pilih Kupon',
  v3UnavailableCoupons: 'Tidak bisa pakai Kupon',
  v3OneCouponPerOrder: 'Setiap pesanan hanya boleh 1',
  v3DiscountCoupon: 'Kupon Diskon',
  v3ThresholdCoupon: 'Kupon Diskon Nominal',
  v3MinSpendCoupon: 'Perlu mencapai xx USD',
  v3MaxDiscountCoupon: 'Max diskon xxxx USD',
  v3LimitedChannel: 'Metode Tertentu',
  v3AllChannels: 'Semua Metode',
  v3SpecificProducts: 'Item Tertentu',
  v3AllProducts: 'Semua Item',
  v3NotYetTimeToUse: 'Bukan waktu pemakaian',
  v3Expired: 'Expired',
  v3Used: 'Digunakan',
  v3ValidityPeriod: 'Masa berlaku:',
  v3ConfirmUse: 'Konfirmasi',
  v3ChangeProduct: 'Ganti Item',
  v3ConfirmPaymentOrder: 'Konfirmasi bayar pesanan',
  v3StoredValueRole: 'Karakter Top-up',
  v3TotalNProducts: 'Total ${n} item',
  v3SelectPaymentMethod: 'Pilih cara pembayaran',
  v3PayNow: 'Segera Bayar',
  v3MorePaymentMethods: 'Cara pembayaran lain',
  v3NoAvailablePaymentMethodContactSupport:
    'Tidak ada metode pembayaran yang bisa digunakan? Hubungi CS',
  v3AvailableCoupons: 'Bisa pakai Kupon',
  v3Extra10Percent: 'Tambah 10%',
  v3LastSelection: 'Pilihan Sebelumnya',
  v3RecommendedUsage: 'Rekomendasi',
  v3PopularChoice: 'Populer',
  v3PaymentSuccess: 'Berhasil',
  v3PaymentFailure: 'Gagal',
  v3TopUpFailureMessage:
    'Maaf, Top-up gagal. Silakan Anda coba kirim ulang pesanan atau hubungi kami via tombol CS di bawah',
  v3Game: 'Game',
  v3UID: 'UID',
  v3OrderNumber: 'No Pesanan',
  v3ProductContent: 'Konten Item',
  v3ViewProductDetails: 'Cek Rincian Item',
  v3PaymentMethod: 'Cara Pembayaran',
  v3Complete: 'Selesai',
  v3TopUpAgain: 'Top-up lagi',
  v3FriendlyReminderSaveOrderInfo:
    'Tips: Screenshot dan simpan info pesanan agar kami bisa mengurus pesanan Anda dengan cepat',
  v3RechargeAgain: 'Top-up Ulang',
  v3TransactionInProgress: 'Transaksi berlangsung',
  v3CompletePaymentInChannel:
    'Silakan selesaikan pembayaran pesanan via metode pembayaran',
  v3RestAssuredFastDeliveryAfterPayment:
    'Jangan khawatir, setelah kami menerima hasil pembayaran pesanan, kami akan mengirim item ke Anda secepat mungkin.',
  v3SaveOrderInfoForProgress:
    'Anda dapat screenshot untuk simpan info pesanan untuk konfirmasi progres transaksi',
  v3PaymentCompleted: 'Aku sudah bayar',
  v3AddToHomeScreen: 'Tambahkan ke layar beranda',
  v3AddShortcutForBonus: 'Tambahkan pintasan desktop, klaim hadiah ekstra',
  v3ShareSuccess: 'Berhasil bagikan',
  v3ShareFailure: 'Gagal bagikan',
  v3RewardClaimed: 'Berhasil Klaim',
  v3RewardClaimFailed: 'Gagal klaim hadiah',
  v3EventNotStarted: 'Event belum dimulai',
  v3EventEnded: 'Event Berakhir',
  v3ClickSelectCoupon: 'Klik untuk memilih kupon',
  v3CouponsRecommendedUsed: 'Kupon yang direkomendasikan telah digunakan',
  v3CouponsSelected: 'Kupon yang dipilih',
  v3NoCouponsAvaliable: 'Tidak ada kupon yang tersedia',
  v3SupplementStatus: 'Status',
  v3SupplementNormal: 'Normal',
  v3SupplementBanned: 'Dilarang',
  v3SupplementPendingPayment: 'Pembayaran Tertunda',
  v3SupplementSwitchCharacter: 'Ganti Karakter',
  v3SupplementAccountInfoInvalid: 'Informasi Akun Tidak Valid',
  v3SupplementContactGSForTopUpLink:
    'Silakan hubungi GS untuk tautan isi ulang',
  v3SupplementTopUpCompleted: 'Isi Ulang Selesai:',
  v3SupplementTotalRefundOrders: 'Total {} Pesanan Pengembalian Dana',
  v3SupplementPendingSupplementAmount: 'Jumlah Pembayaran Tertunda:',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'Akun/Karakter Normal, Tidak Perlu Pembayaran',
  v3SupplementEnjoyYourGame: 'Selamat Bermain!!',
  v3SupplementOrderInformation: 'Informasi Pesanan',
  v3SupplementPendingPaymentAmount: 'Jumlah Pembayaran Tertunda:',
  v3LookUpCouponRule: 'Lihat aturan pemberian kupon',
  v3SwitchOldVersion: 'Beralih ke versi lama Platform pembayaran',
  v3FirstTopUpGiveaway: 'Bonus Top Up Perdana',
  v3SecureConnection: 'Menghubungkan dengan aman',
  v3RequestTimeOut: 'Waktu muat habis, coba lagi nanti',
  v3ConfirmLeave: 'Yakin mau keluar?',
  v3NoSubmitOrder:
    'Keranjang belanja Anda belum dibayar. Barang favorit bisa kehabisan jika Anda pergi!',
  v3ContinueSubmit: 'Lanjut belanja',
  v3LeaveSubmit: 'Keluar',
  v3RecentBug: 'Pembelian terbaru',
  v3ScanCodeLogin: 'Masuk Pihak Ketiga',
  v3BindRole: 'Ikat Karakter',
  v3ScanLoading: 'Sedang memuat...',
  v3ScanExpired: 'Kode telah kedaluwarsa',
  v3ScanRefreshClick: 'Silakan klik refresh lalu coba lagi',
  v3ScanRefreshTip: 'Silakan refresh lalu pindai kode kembali untuk otorisasi',
  v3ScanRefresh: 'Refresh',
  v3ScanSucc: 'Pemindaian berhasil',
  v3ScanAuth: 'Silakan konfirmasi otorisasi di ponsel',
  v3ScanAuthSuccess: 'Otorisasi berhasil',
  v3ScanAuthSuccessTip: 'Sedang login...',
  v3ScanUnauthorized: 'Belum diotorisasi',
  v3ScanRefreshTip2: 'Buka game lalu masuk untuk pindai kode',
  v3ScanGuide: 'Panduan Memindai Kode',
  v3ScanLoginError: 'Terjadi kesalahan saat login, silakan refresh lalu coba lagi',
  v3ThirdPartyLogin: 'Masuk Pihak Ketiga',
  v3NoMyLoginMethod: "Metode login saya tidak tersedia?",
  v3AccountPasswordLogin: 'Masukkan Akun untuk Bind Karakter',
  v3PwaTapShareOrMenuIcon: 'Klik ikon Bagikan atau Menu di bilah alat browser',
  v3PwaFindAndTapAddToHomeScreen: 'Temukan dan klik "Tambahkan ke Layar Utama" di opsi',
  v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox',
  v3ClaimSuccessCheckMailbox: 'Klaim Berhasil\nSilakan cek kotak surat dalam game',
  v3NoAvailableProducts: 'Karakter saat ini tidak memiliki item yang dapat dibeli.\nSilakan pilih karakter dengan level di atas 10 dan pastikan karakter tersebut online.',
  v3IngameLimitedExtraCoinLabel: 'Bonus',
  v3IngameLimitedExtraCoinCountdownText: 'Tersisa ${days} hari ${hours} jam',
  v3IngameLimitedExtraCoin: 'Hadiah Terbatas Waktu',
  v3FirstPayIconRightText: 'Top Up Pertama',
  v3ProductLimitOnceBadge: 'SEKALI',
  v3ProductWeeklyOnlyBadge: 'MINGGUAN',
  v3ProductMonthlyOnlyBadge: 'BULANAN',
  v3ProductDiscountBadge: '**% DISKON',
};
